import app from 'app';
import templateUrl from './settingsMenu.html';
import './settingsMenu.scss';
import { unsetAmplitudeUser } from 'helpers/analytics';

function SettingsMenuCtrl(App, Cards, matchmedia, Session) {
  const SettingsMenu = this;

  SettingsMenu.$onChanges = () => {
    if (SettingsMenu.currentUser) {
      matchmedia.onDesktop((mql) => {
        SettingsMenu.isOnDesktop = mql.matches;
      });

      SettingsMenu.memberName =
        SettingsMenu.currentUser.user.firstName +
        ' ' +
        SettingsMenu.currentUser.user.lastName;
    }
  };

  SettingsMenu.hasMultipleSponsorships = () => {
    return (
      SettingsMenu.allSponsorships &&
      SettingsMenu.allSponsorships.sponsorships.length > 1
    );
  };

  SettingsMenu.viewCards = () => {
    SettingsMenu.$close();

    Cards.openModal({
      currentUser: SettingsMenu.currentUser,
      currentSponsorship: SettingsMenu.currentSponsorship,
    });
  };

  SettingsMenu.signOut = () => {
    SettingsMenu.$close();
    unsetAmplitudeUser();
    Session.logout();
  };
}

app.component('settingsMenu', {
  bindings: {
    allSponsorships: '<',
    $close: '<',
    hasCards: '<',
    currentUser: '<',
    currentSponsorship: '<',
  },
  controller: SettingsMenuCtrl,
  controllerAs: 'SettingsMenu',
  templateUrl,
});

export default 'settingsMenu';
